import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializerService } from '@app/app-initializer.service';
import { ServiceWorkerService } from './service-worker.service';

@Injectable({
	providedIn: 'root'
})
export class CacheBusterService {

	setInterval;

	constructor(
		private http: HttpClient,
		private appInit: AppInitializerService,
		private serviceWorker: ServiceWorkerService
	) { }

	async checkAppVersion() {
		// const config = await this.loadFile('assets/build-details.json');
		const config = await this.loadFile('/configuration.json');
		console.log(config.configuration.VERSION, this.appInit.configuration.VERSION);
		if (config.configuration.VERSION !== this.appInit.configuration.VERSION) {
			console.log('load ->', this.serviceWorker.updateAvailable.value);
			if (!this.serviceWorker.updateAvailable.value) {
				this.serviceWorker.updateAvailable.next(true);
			}
			if (this.setInterval) {
				clearInterval(this.setInterval);
			}
		}
	}

	private async loadFile(file): Promise<any> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Cache-Control': 'no-cache',
				'ngsw-bypass': 'true'
			})
		};
		return this.http.get(file, httpOptions).toPromise();
	}

	checkForAppUpdate() {
		this.setInterval = setInterval(() => {
			if (navigator.onLine) {
				this.checkAppVersion();
			}
		}, 10000);
	}
}
